import localMethod from '@/utils/localMethod';
import type { AimetaWindow } from '@/utils/platform';
import { ensureTrailingSlash, normalizeUrlBase } from '@/utils/urlBase';

function readInjectedServerUrl(): string {
  if (typeof window === 'undefined') return '';
  const url = (window as AimetaWindow).__AIMETA_SERVER_URL;
  return typeof url === 'string' ? normalizeUrlBase(url) : '';
}

let serviceConfig: Record<string, string> = {};
try {
  serviceConfig = (await localMethod.getServiceConfig()) as Record<string, string>;
} catch (e) {
  console.warn('getServiceConfig failed:', e);
}

/** API 服务根地址（末尾带 /） */
export const apiBaseUrl = ensureTrailingSlash(
  serviceConfig?.ServerUrl ||
    readInjectedServerUrl() ||
    import.meta.env.VITE_API_BASE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '')
);

/** 直播间 Web 静态资源根地址（末尾带 /），与 config ClientUrl 一致 */
export const liveRoomBaseUrl = ensureTrailingSlash(
  serviceConfig?.ClientUrl ||
    import.meta.env.VITE_LOCAL_PATH ||
    (typeof window !== 'undefined' ? window.location.origin : '')
);
